import React from "react";

/* ============================================================
   kon nimi — a small hand-drawn plant mark per growth stage.
   0 soil, 1 seed, 2 sprout, 3 leaf, 4 flower. Strokes use
   currentColor so CSS controls color per stage class.
   ============================================================ */

const Soil = () => (
  <svg viewBox="0 0 30 34" aria-hidden="true">
    <path
      d="M4 27c3-2 6-3 11-3s9 1.5 11 3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="11" cy="25" r="0.9" fill="currentColor" />
    <circle cx="18" cy="26.5" r="0.7" fill="currentColor" />
    <circle cx="15" cy="24" r="0.6" fill="currentColor" />
  </svg>
);

const Seed = () => (
  <svg viewBox="0 0 30 34" aria-hidden="true">
    <path
      d="M4 27c3-2 6-3 11-3s9 1.5 11 3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13 25c0-2.4 1-3.6 2.2-3.6s2.2 1.2 2.2 3.6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const Sprout = () => (
  <svg viewBox="0 0 30 34" aria-hidden="true">
    <path
      d="M4 28c3-2 6-3 11-3s9 1.5 11 3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15 25c.4-6 .2-10 .6-14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M15.4 18c-2-.6-3.6-2-4.2-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M15.8 14.5c2-.4 3.4-1.6 4.2-3.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const Leaf = () => (
  <svg viewBox="0 0 30 34" aria-hidden="true">
    <path
      d="M4 29c3-2 6-3 11-3s9 1.5 11 3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15 26c.3-9 0-15 .8-21"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M15.4 21c-2.2-.4-4-1.8-5-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15.7 16c2.2-.3 3.8-1.6 4.8-3.6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M16 11c-1.8-.6-3-1.8-3.7-3.6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

const Flower = () => (
  <svg viewBox="0 0 30 34" aria-hidden="true">
    <path
      d="M4 29c3-2 6-3 11-3s9 1.5 11 3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15 26c.2-7 .1-11 .3-14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M15.3 20c-2-.4-3.5-1.6-4.4-3.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <g fill="currentColor" opacity="0.35">
      <circle cx="15.4" cy="6.4" r="3.1" />
      <circle cx="11.9" cy="8.6" r="3.1" />
      <circle cx="18.9" cy="8.6" r="3.1" />
      <circle cx="13" cy="12.1" r="3.1" />
      <circle cx="17.8" cy="12.1" r="3.1" />
    </g>
    <circle
      cx="15.4"
      cy="9.3"
      r="1.7"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.3"
    />
  </svg>
);

const STAGE_MARKS = [Soil, Seed, Sprout, Leaf, Flower];

const PlantMark = ({ stage }) => {
  const Mark = STAGE_MARKS[stage] || Soil;
  return <Mark />;
};

export default PlantMark;
